<template>
    <ul class="ut--mx-4 sm:ut--mx-0">
        <slot></slot>
    </ul>
</template>

<script>
export default {
  name: 'TimelineAccordian',
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    ul {
        @apply  ut-relative;

        &:before {
        @apply ut-absolute ut-inset-y-0 ut-ml-8;
        content: " ";
        border: 1px solid #DEE0E3;
        height: 100%;
        }
    }
</style>
